// extracted by mini-css-extract-plugin
module.exports = {"page":"Home_page_17XyX","hide":"Home_hide_Q94O4"};